import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { apiQuery } from '@api/api.config';

type BaseQueryType = ReturnType<typeof fetchBaseQuery>;
type BaseQueryAuthType = (url: string, isApplication?: boolean) => BaseQueryType;

export const apiQueryAuth: BaseQueryAuthType =
  (url: string, isApplication = false) =>
  async (args, api, extraOptions) => {
    return await apiQuery(url, isApplication)(import.meta.env.VITE_API_SHARED_URL)(args, api, extraOptions);
  };
